import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const initialSnapshot = useRef(null);
  const location = useLocation();

  useEffect(() => {
    if (updateAvailable) return; // already flagged — no need to keep checking

    const check = async () => {
      try {
        const res = await fetch(
          `${process.env.PUBLIC_URL}/asset-manifest.json?_t=${Date.now()}`,
          { cache: "no-store" }
        );
        if (!res.ok) return;
        const text = await res.text();
        if (!initialSnapshot.current) {
          initialSnapshot.current = text;
        } else if (text !== initialSnapshot.current) {
          setUpdateAvailable(true);
        }
      } catch {
        // offline or fetch failed — silently ignore
      }
    };

    check();
  }, [location, updateAvailable]); // fires on every page navigation

  return updateAvailable;
};

export default useVersionCheck;
